module.exports = __webpack_public_path__ + "static/media/archive.da67d9ce.svg";